import React from 'react';
import { IconButton, colors, makeStyles } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

import DeleteMenu from 'components/menu/DeleteMenu';

const useStyles = makeStyles({
  deleteButton: {
    color: colors.red[900],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const CoverPhotoDeleteButton = ({ onDeleteButtonClick }) => {
  const classes = useStyles();

  return (
    <DeleteMenu
      message={
        <span>
          Click again to <b>remove</b> cover photo
        </span>
      }
      onDeleteButtonClick={onDeleteButtonClick}
      renderButton={(onClick) => (
        <IconButton className={classes.deleteButton} onClick={onClick}>
          <Delete></Delete>
        </IconButton>
      )}
    ></DeleteMenu>
  );
};

export default CoverPhotoDeleteButton;
